import { motion } from "framer-motion";

/**
 * Animated, theme-aware client-side encryption mockup: a bookmark whose fields
 * "lock" into ciphertext, with a key form. Replaces encryption screenshots.
 */

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.2 } },
};
const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export const EncryptionMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--encryption ${className}`}
      variants={container}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">
          <i className="bi bi-shield-lock-fill me-1" />
          Encrypted bookmark
        </div>
      </div>

      <div className="obm-mock__body">
        <motion.div className="obm-mock__enc-toggle" variants={item}>
          <span>
            <i className="bi bi-lock-fill me-2" />
            End-to-end encryption
          </span>
          <span className="obm-mock__switch is-on">
            <span className="obm-mock__knob" />
          </span>
        </motion.div>

        <motion.label className="obm-mock__field-label" variants={item}>
          Encryption key
        </motion.label>
        <motion.div className="obm-mock__field" variants={item}>
          <i className="bi bi-key-fill" />
          <span className="obm-mock__dots">••••••••••••</span>
        </motion.div>

        <motion.div className="obm-mock__cipher" variants={item}>
          <div className="obm-mock__cipher-row">
            <span className="obm-mock__cipher-label">title</span>
            <span className="obm-mock__cipher-val">9f2a·c41e·77bd·a0…</span>
          </div>
          <div className="obm-mock__cipher-row">
            <span className="obm-mock__cipher-label">url</span>
            <span className="obm-mock__cipher-val">b83c·1de9·44af·2c…</span>
          </div>
        </motion.div>

        <motion.div className="obm-mock__enc-note" variants={item}>
          <i className="bi bi-check-circle-fill" />
          Encrypted on your device. Server never sees plaintext
        </motion.div>
      </div>
    </motion.div>
  );
};

export default EncryptionMock;
